import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from './auth.service';
import { ToastService } from '../toast/toast.service';
import { Types } from 'shared-lib';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const allowedRoles = route.data?.['roles'];
    const isAllowed = this.authService.isAllowed(allowedRoles);

    if (isAllowed) {
      return true;
    } else {
      this.router.navigate(['login']);
      this.toastService.add(
        `Você não possui permissão para acessar esta área (${route.url})!`,
        30000,
        'warning'
      );
      return false;
    }
  }
}
